import styles from './ChatSidebar.module.scss';

export const TypingIndicator = () => {
	return (
		<div className={styles.typingIndicator}>
			<div className={styles.typingDot}></div>
			<div className={styles.typingDot}></div>
			<div className={styles.typingDot}></div>
		</div>
	);
};
